export default __webpack_public_path__ + "static/media/Header-PP.1208b3ad.jpg";